/**
 * Per-action USD prices drawn down from a workspace's monthly credits. Used by
 * the pricing copy and by marketing pages that turn a credit amount into "how
 * many screenings". Keep in step with the backend's metering.
 */
export const UNIT_PRICES_USD = {
	emailRecipient: 0.002,
	aiReview: 0.005,
	linkedinLookup: 0.02,
} as const;
